import React, {useEffect} from 'react'

import template from './info-1.twig'

import parse from 'html-react-parser'

import legacyJs from './info-1.legacy'

import {
  Asset,
  ButtonOptions,
  ContentOptions,
  HeadlineOptions,
  LabelOptions,
  LinkOptions,
  Offset,
} from '@miro-site/components_utils'

type Info1Tab = {
  background?: 'blue' | 'pink' | 'yellow'
  image_mini?: {
    src: string
  }
  title?: {
    html: string
  }
  content?: ContentOptions
  link?: LinkOptions
  image_big?: Asset
}

export interface Info1Props {
  background?: 'blue' | 'pink' | 'yellow'
  offset?: Offset
  label?: LabelOptions
  headline?: HeadlineOptions
  content?: ContentOptions
  button?: ButtonOptions
  link?: LinkOptions
  tabs?: Info1Tab[]
  image?: Asset
  children?: React.ReactNode
}

const Hero10 = (props: Info1Props): React.ReactElement => {
  useEffect(() => {
    legacyJs.init()
  }, [])

  return (
    <>
      {parse(
        template({
          ...props,
          component_name: 'Hero Section',
          ctf_assets: 'images.ctfassets.net',
        }),
      )}
    </>
  )
}

export default Hero10
